import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { ClientDashboardController } from './ClientDashboard.controller'
import React from 'react'

/**
 * Page representing the overall client dashboard content.
 *
 * @example <ClientDashboard />
*/
export const ClientDashboard: React.FC = () => {

  return (
    <BKBNThemeWrapper>
      <ClientDashboardController />
    </BKBNThemeWrapper>
  )
}
